import dayjs from 'dayjs';
import { computed, makeObservable, toJS } from 'mobx';

import Configuracao from '@/util/Configuracao';

import { Filtro } from './Filtro';

export default class FiltroMovimentoDecisaoSessaoAnterior extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    constructor(props) {
        super({ ...props, exibeTotalizadores: false });

        makeObservable(this, {
            tipo: true,
            exibicao: true,
            selecaoMultipla: true,
            getValorOpcao: true,
            getDescricao: true,
            equals: true,
            isValoresMovimentos: true,
            isValoresDecisoes: true,
            sort: true,
            renderCarregando: true,
            label: computed,
            labelMovimento: computed,
            labelDecisao: computed,
            carregandoDadosComplementares: computed
        });
    }

    get label() {
        return `${
            this.labelMovimento && this.labelDecisao
                ? `${this.labelMovimento}/${this.labelDecisao}`
                : this.labelMovimento || this.labelDecisao
        } na sessão imediatamente anterior`;
    }

    get labelMovimento() {
        return this.store.existeSessaoPJe ? 'Movimentos CNJ' : undefined;
    }

    get labelDecisao() {
        return this.store.rootStore.parametroStore.isOrgaoTST && this.store.existeSessaoSIJ ? 'Decisão' : undefined;
    }

    getValorOpcao(registro) {
        const julgamentosAnteriores = registro?.detalhes?.julgamentosAnteriores;

        if (!julgamentosAnteriores?.length) {
            return [];
        }

        // 1. Ordena de forma DECRESCENTE (mais recente primeiro)
        // FIXME Substituir a data de julgamento pela da sessão de acordo com o meio de julgamento
        const julgamentosOrdenados = [...julgamentosAnteriores].toSorted((a, b) => {
            const dateA = dayjs(a.dataJulgamento, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO);
            const dateB = dayjs(b.dataJulgamento, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO);

            // Se dateB é depois de dateA, B vem primeiro (Decrescente)
            return dateB.diff(dateA);
        });

        if (!julgamentosOrdenados?.length) {
            return [];
        }

        const ultimoApreciado = julgamentosOrdenados[0];

        // 3. Monta o retorno apenas para este item específico
        let retorno = [];

        if (ultimoApreciado.decisao) {
            retorno.push(ultimoApreciado.decisao);
        }

        if (ultimoApreciado.movimentos) {
            retorno = [...retorno, ...toJS(ultimoApreciado.movimentos)];
        }

        return retorno;
    }

    getDescricao(valor) {
        if (valor) {
            if (valor.id) {
                return valor.id + ' - ' + valor.descricao;
            }

            if (valor.numeroMovimentoCnj) {
                const movimentoOriginal = this.store.rootStore.dominioStore.movimentoOriginal(valor.numeroMovimentoCnj);
                return valor.numeroMovimentoCnj + (movimentoOriginal ? ' - ' + movimentoOriginal.descricao : '');
            }
        }

        return '';
    }

    equals(valor1, valor2) {
        if (valor1 && valor2) {
            return (
                (this.isValoresDecisoes(valor1, valor2) && valor1.id === valor2.id) ||
                (this.isValoresMovimentos(valor1, valor2) && valor1.numeroMovimentoCnj === valor2.numeroMovimentoCnj)
            );
        }

        return false;
    }

    isValoresMovimentos(valor1, valor2) {
        return valor1.numeroMovimentoCnj && valor2.numeroMovimentoCnj;
    }

    isValoresDecisoes(valor1, valor2) {
        return valor1.id && valor2.id;
    }

    sort(opcao1, opcao2) {
        const valor1 = opcao1.valor.id || opcao1.valor.numeroMovimentoCnj;
        const valor2 = opcao2.valor.id || opcao2.valor.numeroMovimentoCnj;
        return valor1 > valor2 ? 1 : -1;
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoJulgamentosAnteriores;
    }

    renderCarregando() {
        return this.renderCircularProgress('resultados de apreciação de sessões anteriores...');
    }
}
